import React from "react";
import { useRef,useContext,useEffect,useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../pages/inc/Header";
import Footer from "../pages/inc/Footer";
import Userprofile from "./Trainer/User_profile";
import TrainersessionCreate from "./Trainer/trainerequest";
import Banner from "./About/Banner";
import { GlobalContext } from '../GlobalContext';
import { useTranslation } from 'react-i18next';
import Popmodal from "../pages/inc/popmodal";


const Home = () => {
const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const userprofile = {
    "name":"John Doe",
    "description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed congue, nulla nec cursus lacinia, mauris nibh accumsan tellus, et ultrices quam nisl non nulla. Nunc laoreet quis lectus eu hendrerit.",
    "logo" : "img/cfn-banner-logo.svg"
  }
  const bannerdata = {
      img:"img/about-cfan.jpg",
      titleone:t('Request_a_One2One_Training'),
      titletwo:t('Request_a_One2One_Training'),
      
    };
    

  return (   
    <>
    <div class="loader d-none" id="loder-tive">
	<div class="loader-content">
		<div id="loader-animation"></div>
	</div>
</div>
    <Header/>
    <TrainersessionCreate  />
    <Footer/>
   <Popmodal/>
    </>
  );
};

export default Home;